module.exports = __webpack_public_path__ + "static/media/3DPPA23.7b83a9e2.jpg";